import {Component, OnInit} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DocumentValutService } from 'src/app/share/document-valut/document-valut.service';
import { SdexAdminService } from 'src/app/share/services/sdex/sdex-admin.service';
import { EsignPositonComponent } from 'src/app/utilities/esign-positon/esign-positon.component';
import { submitForm } from 'src/app/share/esign-document';

@Component({
    selector: 'app-document-esign',
    templateUrl: './document-esign.component.html',
    styleUrl: './document-esign.component.scss',
    standalone: false
})
export class DocumentEsignComponent implements OnInit{
  docDetails: any;
  accessToken: any;
  companyId: any;
  docId: any;
  isLoadRecords: boolean = false;
  documentId: any;
  surl: any;
  furl: any;
  curl: any;
  esignName: any;
  adharNumber: any;

  constructor(
    private readonly route: ActivatedRoute,
    private readonly sdexAdminService: SdexAdminService,
    private readonly modalService: NgbModal,
    private readonly documentValutService: DocumentValutService,
  ) {
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.accessToken = params['accessToken'] || null;
      this.docId = params['docId'] || null;
      this.surl = params['surl'] || null;
      this.furl = params['furl'] || null;
      this.curl = params['curl'] || null;
      this.esignName = params['esignName'] || null;
      this.adharNumber = params['adharNumber'] || null;
      if (this.docId) {
        this.getDocumentId(this.docId);
      }
    });
  }

  getDocumentId(rootCompanyDocument: any) {
    this.sdexAdminService.getDocumentId(rootCompanyDocument, { tempBearer: `${this.accessToken}` })?.subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.documentId = res?.data[0]?.docId || this.documentId;
          this.initializeStandalone();
        }
      },
      error: () => {
      }
    });
  }

  initializeStandalone() {
    const queryParams: any = {};
    if (this.surl) queryParams.surl = this.surl;
    if (this.furl) queryParams.furl = this.furl;
    if (this.curl) queryParams.curl = this.curl;
    if(this.esignName) queryParams.esignName = this.esignName;
    if(this.adharNumber) queryParams.adharNumber = this.adharNumber;
    this.sdexAdminService.getEsignData(this.documentId, { overwriteEsign: true }, { tempBearer: `${this.accessToken}` }, queryParams)?.subscribe({
      next: (res: any) => {
        if (res?.success) {
          this.docDetails = res.data?.documentDetails;
          this.openEsignPositionModal();
        }
      },
      error: () => {
      }
    })
  }

  openEsignPositionModal() {
    const esignPositionPopup = this.modalService.open(EsignPositonComponent, {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      fullscreen: true,
    });
    esignPositionPopup.componentInstance.isShowUsers = false;
    esignPositionPopup.componentInstance.redirectOnClose = true;

    this.documentValutService
      .downloadFile({ _id: this.documentId, download: true, forEsign: true }, true, {}, { tempBearer: `${this.accessToken}` })
      ?.subscribe({
        next: (res: any) => {
          const files = new Blob([res.body], { type: 'application/pdf' });
          const pdfSrc = URL.createObjectURL(files);
          esignPositionPopup.componentInstance.pdfSrc = pdfSrc;
        }
      });

    this.documentValutService.getPageDimensions(this.documentId, { tempBearer: `${this.accessToken}` })?.subscribe({
      next: (dimRes: any) => {
        const pageDimanesions = dimRes?.data?.pageDimanesions || [];
        const width = pageDimanesions?.[0]?.width;
        const height = pageDimanesions?.[0]?.height;
        const isUniqDimensions = pageDimanesions.every((object: any) => object.width === width && object.height === height);
        esignPositionPopup.componentInstance.isUniqDimensions = isUniqDimensions;
        esignPositionPopup.componentInstance.pageDimanesions = pageDimanesions;
      }
    });

    esignPositionPopup.result.then((result: any) => {
      if (!result) { return; }
      if (result?.redirect && this.curl) {
        window.location.href = this.curl;
        return;
      }
      const signPositions = Array.isArray(result) ? [result] : [];
      const req: any = { documentDetails: this.docDetails, signPositions };
      const selectedFile: any = { _id: this.docId };
      this.openEsignLink(req, selectedFile);
    }, () => {
    });
  }

  openEsignLink(req: any, selectedFile: any) {
    this.isLoadRecords = true;
    const queryParams: any = {};
    if (this.surl) queryParams.surl = this.surl;
    if (this.furl) queryParams.furl = this.furl;
    if (this.curl) queryParams.curl = this.curl;
    if (this.esignName) queryParams.esignName = this.esignName;
    if (this.adharNumber) queryParams.adharNumber = this.adharNumber;
    this.sdexAdminService
      .eSignLink(this.companyId, selectedFile?._id, req, { tempBearer: `${this.accessToken}` }, queryParams)
      ?.subscribe({
        next: (res: any) => {
          this.isLoadRecords = false;
          if (res?.data) {
            submitForm(res.data, (_err: any, id: any) => {
            },true);
          }
        },
        error: () => {
          this.isLoadRecords = false;
          console.error('Error occurred while generating e-sign link');
        }
      });
  }

}
